import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromAnalysis from '../reducers/analysis.reducer';

export const selectAnalysis = createSelector(
  fromFeature.getAnalysisItem,
  (state: any) => state.data
);

export const getModule = createSelector(
  selectAnalysis,
  fromAnalysis.getAnalysis
);

export const getModuleLoaded = createSelector(
  selectAnalysis,
  fromAnalysis.getAnalysisLoaded
);

export const getModuleLoading = createSelector(
  selectAnalysis,
  fromAnalysis.getAnalysisLoading
);

export const getModuleDocuments = createSelector(
  selectAnalysis,
  fromAnalysis.getAnalysisDocuments
);

export const getInfos = createSelector(selectAnalysis, fromAnalysis.getInfos);

export const getConfig = createSelector(
  selectAnalysis,
  fromAnalysis.getConfig
);


export const getModuleReasons = createSelector(selectAnalysis, fromAnalysis.getAnalysisReasons);

export const getCallEsocial = createSelector(selectAnalysis, fromAnalysis.getCallEsocial);

export const getError = createSelector(selectAnalysis, fromAnalysis.getError);
